/* ============================================================
   YOSHIMURA PLANTS — theme.js
   グローバル JS（ヘッダースクロール・FAQ等）
============================================================ */

(function() {
  'use strict';

  /* Header scroll shadow */
  var header = document.getElementById('shopHeader');
  if (header) {
    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > 50);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* FAQ accordion */
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.parentElement;
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i) {
        i.classList.remove('open');
      });
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* Fade-in on scroll */
  var fades = document.querySelectorAll('.fade-in');
  if (fades.length > 0 && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) e.target.classList.add('visible');
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    fades.forEach(function(el) { io.observe(el); });
  }

  /* Newsletter opening popup (one-time) */
  function showNewsletterPopup() {
    if (localStorage.getItem('yp_newsletter_shown')) return;
    setTimeout(function() {
      var existing = document.getElementById('newsletterPopup');
      if (existing) existing.classList.add('open');
      localStorage.setItem('yp_newsletter_shown', '1');
    }, 15000);
  }
  showNewsletterPopup();

})();
